<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-lg-8 mr-auto ml-auto  col-md-10">
				<form class="form-horizontal" action="." method="post">
					<fieldset>
						<legend>{{ 'General information' | translate }}</legend>
						<div v-if="showMasterList" class="row form-group">
							<label class="col-md-5">
								{{ 'Master Franchise' | translate }} *
							</label>
							<div class="col-md-7">
								<v-select :on-change="changeMaster" :options="masterList" />
							</div>
						</div>
						<div class="row form-group">
							<label class="col-md-5">Email *</label>
							<div class="col-md-7">
								<input
									type="email"
									:class="{ error: error.email }"
									v-model="email"
									class="form-control"
								/>
							</div>
							<label class="col-12 text-right text-danger" v-if="error.email">
								{{ error.email }}
							</label>
						</div>
						<div class="row form-group">
							<label class="col-md-5">{{ 'Phone number' | translate }} *</label>
							<div class="col-md-7">
								<input
									type="text"
									:class="error.number ? 'error' : ''"
									v-model="number"
									class="form-control"
								/>
							</div>
							<label class="col-12 text-right text-danger" v-if="error.number">
								{{ error.number }}
							</label>
						</div>
						<div class="row form-group">
							<label class="col-md-5">{{ 'First name' | translate }}</label>
							<div class="col-md-7">
								<input type="text" v-model="firstName" class="form-control" />
							</div>
						</div>
						<div class="row form-group">
							<label class="col-md-5">{{ 'Surname' | translate }}</label>
							<div class="col-md-7">
								<input type="text" v-model="middleName" class="form-control" />
							</div>
						</div>
						<div class="row form-group">
							<label class="col-md-5">{{ 'Last name' | translate }}</label>
							<div class="col-md-7">
								<input type="text" v-model="lastName" class="form-control" />
							</div>
						</div>
						<div class="row form-group">
							<label class="col-md-5">{{ 'Date of birth' | translate }}</label>
							<div class="col-md-7 date-group">
								<datepicker v-model="birthDay" :format="format"></datepicker>
							</div>
						</div>
						<div class="row form-group">
							<label class="col-md-5">{{ 'Password' | translate }} *</label>
							<div class="col-md-7">
								<input
									type="text"
									:class="{ error: error.password }"
									v-model="password"
									class="form-control"
								/>
							</div>

							<label
								class="col-12 text-right text-danger"
								v-if="error.password"
							>
								{{ error.password }}
							</label>
						</div>
					</fieldset>
					<fieldset>
						<legend>{{ 'Additional information' | translate }}</legend>
						<div class="row form-group">
							<label class="col-md-5">{{ 'Region' | translate }}</label>
							<div class="col-md-7">
								<input type="text" v-model="region" class="form-control" />
							</div>
						</div>
						<div class="row form-group">
							<label class="col-md-5">{{ 'Passport' | translate }}</label>
							<div class="col-md-7">
								<textarea v-model="passport" class="form-control"></textarea>
							</div>
						</div>
						<div class="row form-group">
							<label class="col-md-5">{{ 'Id code' | translate }}</label>
							<div class="col-md-7">
								<input type="text" v-model="idCode" class="form-control" />
							</div>
						</div>
						<div class="row form-group checkbox">
							<label>
								<input type="checkbox" v-model="isEmailSubscribed" />
								{{ 'With email newsletter' | translate }}
							</label>
						</div>
					</fieldset>

					<fieldset class="form-group">
						<legend>{{ 'Language' | translate }}</legend>
						<!-- <div v-if="showEng" class="form-check row">
							<label class="form-check-label col-md-5">
								<input
									type="radio"
									class="form-check-input"
									name="optionsRadios"
									v-model="engStatus"
									value="with"
								/>
								{{ 'With english' | translate }}
							</label>
						</div>
						<div v-if="showEng" class="form-check row">
							<label class="form-check-label  col-md-5">
								<input
									type="radio"
									class="form-check-input"
									name="optionsRadios"
									v-model="engStatus"
									value="without"
								/>
								{{ 'Without english' | translate }}
							</label>
						</div> -->
						<div class="row form-group">
							<label class="col-md-5">
								{{ 'Default language' | translate }} *
							</label>
							<div class="col-md-7">
								<select
									:class="{ error: error.language }"
									class="form-control"
									v-model="language"
								>
									<option value="UA">UA</option>
									<option value="RU">RU</option>
									<option value="AZ">AZ</option>
									<option value="PL">PL</option>
									<option value="HE">HE</option>
									<option value="HY">HY</option>
									<option value="RO">RO</option>
									<option value="EN">EN</option>
									<option value="FR">FR</option>
									<option value="ES">ES</option>
									<option value="CS">CZ</option>
									<option value="DE">DE</option>
									<option value="IT">IT</option>
									<option value="TR">TR</option>
									<option value="EL">EL</option>
								</select>
							</div>
							<label
								class="col-12 text-right text-danger"
								v-if="error.language"
							>
								{{ error.language }}
							</label>
						</div>
					</fieldset>
					<fieldset>
						<legend>{{ 'Financial information' | translate }}</legend>
						<div class="row form-group">
							<label class="col-md-5">{{ 'Royalty' | translate }} *</label>
							<div class="col-md-7">
								<input
									type="number"
									:class="error.royalty ? 'error' : ''"
									@input="filterNegative('royalty')"
									v-model="royalty"
									class="form-control"
								/>
							</div>
							<label class="col-12 text-right text-danger" v-if="error.royalty">
								{{ error.royalty }}
							</label>
						</div>
						<div class="row form-group">
							<label class="col-md-5">{{ 'Royalty' | translate }} EN*</label>
							<div class="col-md-7">
								<input
									:class="error.royaltyEn ? 'error' : ''"
									@input="filterNegative('royaltyEn')"
									type="number"
									v-model="royaltyEn"
									class="form-control"
								/>
							</div>
							<label
								class="col-12 text-right text-danger"
								v-if="error.royaltyEn"
							>
								{{ error.royaltyEn }}
							</label>
						</div>
						<div class="row form-group">
							<label class="col-md-5">
								{{ 'PR contribution' | translate }} *
							</label>
							<div class="col-md-7">
								<input
									type="number"
									:class="error.prDeposit ? 'error' : ''"
									@input="filterNegative('prDeposit')"
									v-model="prDeposit"
									class="form-control"
								/>
							</div>
							<label
								class="col-12 text-right text-danger"
								v-if="error.prDeposit"
							>
								{{ error.prDeposit }}
							</label>
						</div>
						<div class="row form-group">
							<label class="col-md-5">
								{{ 'Contract number' | translate }}
							</label>
							<div class="col-md-7">
								<input
									type="text"
									v-model="contractNumber"
									class="form-control"
								/>
							</div>
						</div>
						<div class="row form-group">
							<label class="col-md-5">
								{{ 'Type of legal activity' | translate }}
							</label>
							<div class="col-md-7">
								<input
									type="text"
									v-model="legalActivity"
									class="form-control"
								/>
							</div>
						</div>
						<div class="row form-group">
							<label class="col-md-5">{{ 'Legal address' | translate }}</label>
							<div class="col-md-7">
								<input
									type="text"
									v-model="legalAddress"
									class="form-control"
								/>
							</div>
						</div>
						<div class="row form-group">
							<label class="col-md-5">
								{{ 'Registration number' | translate }}
							</label>
							<div class="col-md-7">
								<input type="text" v-model="regNumber" class="form-control" />
							</div>
						</div>
						<div class="row form-group">
							<label class="col-md-5">{{ 'Р/Р' | translate }}</label>
							<div class="col-md-7">
								<input type="text" v-model="pp" class="form-control" />
							</div>
						</div>
						<div class="row form-group">
							<label class="col-md-5">{{ 'МФО' | translate }}</label>
							<div class="col-md-7">
								<input type="text" v-model="mfo" class="form-control" />
							</div>
						</div>
						<div class="row form-group">
							<label class="col-md-5">
								{{ 'Сost of education' | translate }} *
							</label>
							<div class="col-md-7">
								<input
									type="number"
									:class="error.minPrice ? 'error' : ''"
									@input="filterNegative('minPrice')"
									v-model="minPrice"
									class="form-control"
								/>
							</div>
							<label
								class="col-12 text-right text-danger"
								v-if="error.minPrice"
							>
								{{ error.minPrice }}
							</label>
						</div>
						<div class="row form-group">
							<label class="col-md-5">
								{{ 'Сost of education' | translate }} EN *
							</label>
							<div class="col-md-7">
								<input
									:class="error.minPriceEn ? 'error' : ''"
									type="number"
									@input="filterNegative('minPriceEn')"
									v-model="minPriceEn"
									class="form-control"
								/>
							</div>
							<label
								class="col-12 text-right text-danger"
								v-if="error.minPriceEn"
							>
								{{ error.minPriceEn }}
							</label>
						</div>
						<div class="row form-group">
							<label class="col-md-5">{{ 'Currency' | translate }} *</label>
							<div class="col-md-7">
								<select class="form-control" v-model="currency">
									<option>UAH</option>
									<option>USD</option>
									<option>RUB</option>
									<option>EUR</option>
									<option>PLN</option>
									<option>AZN</option>
									<option>NIS</option>
								</select>
							</div>
						</div>
					</fieldset>

					<div v-if="myRole === 'super franchise'" class="row form-group">
						<label class="col-md-5">{{ 'Comment' | translate }}</label>
						<div class="col-md-7">
							<textarea
								v-model="comments"
								class="form-control"
								rows="3"
							></textarea>
						</div>
					</div>

					<div class="text-center">
						<p
							class="h4 text-danger"
							style="white-space: pre-wrap;"
							v-if="error.detail"
						>
							{{ error.detail }}
						</p>
						<input
							:disabled="loading"
							@click.prevent="createProfile"
							type="submit"
							:value="'Create' | translate"
							class="btn btn-primary"
						/>
					</div>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'

export default {
	name: 'Franchise',
	data() {
		return {
			loading: false,
			masterList: [],
			myRole: this.$store.state.myProfile.role,
			parent: this.$store.state.myProfile.id,
			number: '',
			showEng: true,
			email: '',
			firstName: '',
			lastName: '',
			middleName: '',
			format: 'dd/MM/yyyy',
			birthDay: null,
			region: '',
			comments: '',
			passport: '',
			royalty: '',
			royaltyEn: '',
			prDeposit: '',
			currency: 'UAH',
			isEmailSubscribed: false,
			contractNumber: '',
			idCode: '',
			legalActivity: '',
			legalAddress: '',
			regNumber: '',
			pp: '',
			mfo: '',
			engStatus: 'with',
			minPrice: 0,
			minPriceEn: 0,
			language: '',
			password: '',
			showMasterList: false,
			error: {
				email: '',
				number: '',
				royalty: '',
				royaltyEn: '',
				prDeposit: '',
				password: '',
				minPrice: '',
				minPriceEn: '',
				language: '',
				detail: '',
			},
		}
	},
	components: {
		vSelect,
		Datepicker,
	},
	methods: {
		filterNegative(prop) {
			if (this[prop] < 0) {
				this[prop] = 0
			} else if (
				(prop === 'royalty' || prop === 'royaltyEn' || prop === 'prDeposit') &&
				this[prop] > 100
			) {
				this[prop] = 100
			}
		},
		createProfile() {
			let error = false
			for (let prop in this.error) {
				if (
					(prop === 'royaltyEn' || prop === 'minPriceEn') &&
					this[prop] === ''
				) {
					if (
						(this.$route.params.role === 'master franchise' &&
							this.engStatus === 'with') ||
						(this.showEng &&
							this.engStatus === 'with' &&
							this.$route.params.role === 'franchise')
					) {
						this.error[prop] = this.$t('Field required')
						error = true
					}
				} else if (this[prop] === '') {
					this.error[prop] = this.$t('Field required')
					error = true
				} else {
					this.error[prop] = ''
				}
			}

			if (error) {
				return false
			}

			let birthday = null
			if (this.birthDay !== null) {
				birthday = this.birthDay.toISOString().slice(0, 10)
			}

			this.loading = true

			this.axios({
				method: 'post',
				url: 'users/user',
				data: {
					phone_number: this.number,
					email: this.email,
					first_name: this.firstName,
					middle_name: this.middleName,
					last_name: this.lastName,
					birthday: birthday,
					role: this.$route.params.role,
					region: this.region,
					passport: this.passport,
					price_min: Number(this.minPrice),
					price_min_en: Number(this.minPriceEn),
					royalty: Number(this.royalty),
					royalty_en: Number(this.royaltyEn),
					pr_deposit: Number(this.prDeposit),
					currency: this.currency.toLowerCase(),
					is_email_subscribed: this.isEmailSubscribed,
					comments: this.comments,
					tax_id: this.idCode,
					legal_activity_type: this.legalActivity,
					legal_address: this.legalAddress,
					legal_id: this.regNumber,
					mfo: this.mfo,
					settlement_account: this.pp,
					default_language: this.language,
					password: this.password,
					contract_number: this.contractNumber,
					parent: this.parent,
					eng_status: this.engStatus,
				},
			})
				.then(data => {
					this.loading = false
					if (data.data.detail) {
						this.error.detail = this.$t(data.data.detail)
					} else {
						this.$router.push({
							name: 'Dashboard List',
							params: { role: this.$route.params.role },
						})
					}
				})
				.catch(error => {
					this.loading = false
					const errors = [
						error.response.data.phone_number?.[0],
						error.response.data.email?.[0],
						error.response.data.detail?.[0],
					].filter(Boolean)
					this.error.detail = this.$t(errors.join('\n'))
				})
		},
		changeMaster(val) {
			this.parent = val.value
			this.showEng = val.en
			this.engStatus = 'with'
			this.minPriceEn = ''
			this.royaltyEn = ''
		},
		getStartInfo() {
			if (
				this.$route.params.role === 'franchise' &&
				this.myRole === 'master franchise'
			) {
				if (
					this.$store.state.myProfile.royalty_en === '' ||
					this.$store.state.myProfile.royalty_en === 0 ||
					this.$store.state.myProfile.royalty_en === null ||
					this.$store.state.myProfile.royalty_en === '0.00'
				) {
					this.showEng = true
				}
			}
			if (
				this.$route.params.role === 'franchise' &&
				this.myRole === 'super franchise'
			) {
				this.showMasterList = true
				this.axios({
					method: 'get',
					url: 'users?role=master franchise',
				}).then(response => {
					let masterArray = response.data
					for (var i = 0; i < masterArray.length; i++) {
						let engStatus =
							masterArray[i].royalty_en !== null &&
							masterArray[i].royalty_en !== ''
						let master = {
							value: masterArray[i].id,
							en: engStatus,
							label:
								masterArray[i].last_name +
								' ' +
								masterArray[i].first_name +
								' ' +
								masterArray[i].middle_name,
						}
						this.masterList.push(master)
					}
				})
			}
		},
	},
	beforeMount() {
		this.getStartInfo()
	},
	watch: {
		$route(from, to) {
			this.getStartInfo()
		},
	},
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.dropdown.v-select.searchable {
	background-color: #fff;
}

textarea {
	height: 150px;
}
</style>
